import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {AutoComplete, Button, notification} from 'antd';
import {
  addApplicableProductForFee,
  getFee,
  removeApplicableProductForFee,
  searchFeeApplicableProducts,
  searchProducts
} from './actions';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {getDescriptionFromError} from "../utils/errors";
import {decodeParams} from "../utils/params";

//import moment from "moment";

class FeeApplicableProductsPage extends Component {
  constructor() {
    super();
    this.state = {
      addProduct: null,
    };
  }

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.feeId !== prevProps.match.params.feeId) this._load();
  }

  _load = (newPagination) => {
    const {feeId} = decodeParams(this.props.match.params);
    this.props.getFee({feeId});
    //this.props.searchFeeApplicableProducts({feeId});
  };

  _search = (search) => {
    search = search || this.props.search;
    const {searchFeeApplicableProducts, match: {params}} = this.props;
    const {feeId} = decodeParams(params);
    const {filters, ...rest} = search;
    searchFeeApplicableProducts({...rest, filters: {...filters, feeId}});
    this.setState({addProduct: null});
  };

  handleAdd = e => {
    e.preventDefault();
    const {feeId} = decodeParams(this.props.match.params);
    const {fee: {name: feeName}} = this.props;
    const {addProduct: {productId, display: productDisplay}} = this.state;
    this.props.addApplicableProductForFee({feeId, productId})
      .then(() => notification.success({message: 'Success', description: `${productDisplay} added to ${feeName}`}))
      .then(this._search)
      .catch(err => notification.error({message: 'Failed', description: getDescriptionFromError(err)}));
  };

  handleRemove = ({feeId, productId}) => {
    const {search: {results}} = this.props;
    const {fee: {name: feeName}} = this.props;
    const {productDisplay} = results.find(x => x.productId === productId);
    this.props.removeApplicableProductForFee({feeId, productId})
      .then(() => notification.success({message: 'Success', description: `${productDisplay} removed from ${feeName}`}))
      .then(this._search)
      .catch(err => notification.error({message: 'Success', description: getDescriptionFromError(err)}));
  };

  handleSelectProduct = (productId) => {
    const {productsSearch: {results: products}} = this.props;
    const addProduct = products.find(x => x.productId === productId);
    this.setState({addProduct});
  };

  handleProductSearch = value => {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(this._searchProduct, 300, value);
  };

  _searchProduct = searchFilter => {
    const {dispensaryId} = this.props;
    const pagination = {pageSize: 20, current: 1};
    this.props.searchProducts({pagination, filters: {dispensaryId}, searchFilter});
  };

  render() {
    const {
      history, fee,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      productsSearch: {searching: productsSearching, results: products},
      addingApplicableProduct,
    } = this.props;
    const {addProduct} = this.state;

    const columns = [
      {
        title: 'Product',
        dataIndex: 'productDisplay',
        key: 'productDisplay',
      },
      {
        title: 'Actions',
        dataIndex: 'productId',
        key: 'productId',
        render: (productId, {feeId}) => <span>
          <a onClick={() => this.handleRemove({feeId, productId})}>Remove</a>
        </span>
      }
    ];

    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          ` Applicable products for ${fee.name}`
        ]}
        searchPlaceholder="Search applicable products"
        loading={searching}
        columns={columns}
        dataSourceProvider={this._search}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        rowKey="productId"
      >
        <div style={{marginBottom: '1em'}}>
          <AutoComplete style={{width: '69%'}} placeholder={"Search products"}
                        onChange={this.handleProductSearch}
                        optionLabelProp="text"
                        backfill={true}
                        onSelect={this.handleSelectProduct}
          >
            {products.map(({productId, display}) => (
              <AutoComplete.Option key={productId} value={productId} text={display}>
                {display}
              </AutoComplete.Option>
            ))}
          </AutoComplete>
          {' '}
          <Button type="primary" icon="plus"
                  loading={addingApplicableProduct}
                  disabled={!addProduct || productsSearching}
                  onClick={this.handleAdd}
          >
            Add
          </Button>
        </div>
      </ListView>
    );
  }
}

FeeApplicableProductsPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  /* state */
  dispensaryId: PropTypes.string.isRequired,
  fee: PropTypes.object.isRequired,
  search: PropTypes.object.isRequired,
  productsSearch: PropTypes.object.isRequired,
  addingApplicableProduct: PropTypes.bool.isRequired,
  /* actions */
  getFee: PropTypes.func.isRequired,
  searchFeeApplicableProducts: PropTypes.func.isRequired,
  searchProducts: PropTypes.func.isRequired,
  addApplicableProductForFee: PropTypes.func.isRequired,
  removeApplicableProductForFee: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  fee: state.fee.fee || {},
  search: state.fee.searchFeeApplicableProducts,
  productsSearch: state.fee.productsSearch,
  addingApplicableProduct: state.fee.addingApplicableProduct,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getFee,
  searchFeeApplicableProducts,
  searchProducts,
  addApplicableProductForFee,
  removeApplicableProductForFee,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FeeApplicableProductsPage);



// WEBPACK FOOTER //
// ./src/Fee/FeeApplicableProductsPage.js